import React from "react";
import styled from "styled-components";
import ProductCard from "./ProductCard";
import { Link } from "react-router-dom";
import { selectProducts, updateCategory } from "../redux/productRedux";
import { useSelector, useDispatch } from "react-redux";

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  a,
  h2 {
    width: 100%;
  }

  h2 {
    font-size: 40px;
    margin: 0 0 30px 5px;
    font-weight: 200;
  }

  button {
    font-size: 40px;
    font-weight: 200;
    background-color: black;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    padding: 10px;
    margin: 30px 0 0 5px;

    @media only screen and (max-width: 768px) {
      margin: 0 0 30px 0;
    }
  }
`;

export default function ProductList() {
  const products = useSelector(selectProducts);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(updateCategory(""));
  };

  return (
    <Container>
      <h2>Featured</h2>
      {products
        .filter(item => item.featured === true)
        .map(item => (
          <ProductCard key={item._id} {...item} />
        ))}
      <Link to="/products">
        <button onClick={handleClick}>View All Products</button>
      </Link>
    </Container>
  );
}
